import { FeeTypeType } from '../../types/index';
import { updateFeeType } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useUpdateFeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (feeTypeNewData: FeeTypeType) => updateFeeType(feeTypeNewData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetFeeTypes"]);
        toast.fire("Success", "Fee Type Updated Successfully", "success");
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Fee Type", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateFeeType;
